import React, { useEffect, useState } from "react"; 
import { maintenanceApi } from "../../Restclient/datacollection";
import { useApiHandler } from '../../hooks/useApiHandler';
import { ErrorTypes } from '../../Restclient/axiosConfig';
import { Checkbox, Typography } from '@mui/material';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import TextField from '@mui/material/TextField';
import AssetTagsRetrieval from './AssetTagsRetrieval';
import { useSelector, useDispatch } from "react-redux";
import { updateplatjson } from "../../store/login_data";
import { getplantview } from "../../Restclient/datacollection";
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import CustomTableHeading from "../CommonComponents/CustomTableHeading";
import CustomActionButton from "../CommonComponents/CustomActionButton";
import CustomCancelButton from '../CommonComponents/CustomCancelButton';
import CustomDialogBox from "../CommonComponents/CustomDialogBox";
import LK_Loading from "../../images/LK_Loading.gif";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CustomMultiSelectwithDefaultOptions from "../CommonComponents/CustomMultiSelectwithDefaultOptions";
import LK_Delete from "../../images/LK_Delete";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    
  } from '@mui/material';
import CustomButton from "../CommonComponents/CustomButton";
import CustomTextField from "../CommonComponents/CustomTextField";
import Questionnaire from "./Questionnaire";
//import {getMaintenanceDashboardList,deleteMaintenanceDashboard} from "../../Restclient/datacollection";
import CustomTableMetric from '../CommonComponents/CustomTableMetric';

// Utility to refresh plantview and update redux
function refreshPlantview(dispatch, orgid, projid) {
    getplantview(orgid, projid, (res) => {
        if (res && res.data) {
            dispatch(updateplatjson(res.data));
        }
    });
}
export default function PeriodicMaintenanceStandardDashboards(){
    const[configDashboards, setConfigDashboards] = useState([]);
    const dispatch = useDispatch();
    const [loading,setLoading]=useState(true);
    const userdetails = useSelector((state) => state.logindata.userdetails)
    const projectname = useSelector((state) => state.mainpagedata.selectedprojectname);
    const[deleteMode, setDeleteMode] = useState(false);
    const[deleteDashboardObject, setDeleteDashboardObject] = useState(null);
    
    // States for custom dialog messages
    const [deleteDashboardSuccess, setDeleteDashboardSuccess] = useState(false);
    const [deleteDashboardFailed, setDeleteDashboardFailed] = useState(false);
    const [notCreatedMessage, setNotCreatedMessage] = useState('');

    // API Handler with dialog control
    const { 
        callApi, 
        dialogState, 
        closeDialog 
    } = useApiHandler({
        [ErrorTypes.NOT_FOUND]: 'No dashboards found for this project.',
        [ErrorTypes.FORBIDDEN]: 'You do not have permission to manage dashboards.',
        [ErrorTypes.SERVER_ERROR]: 'Unable to load dashboards. Please try again.'
    });

    useEffect(() => {
        fetchDashboards();
    }, [projectname]);

    const fetchDashboards = async () => {
        setLoading(true);
        
        await callApi(
            () => maintenanceApi.getDashboards(),
            {
                // Only show dialog for critical errors
                showDialogOnStatusCodes: [401, 403, 500],  // Show dialog for these errors
                hideDialogOnStatusCodes: [404],            // Don't show dialog for 404
                useBackendMessage: true,                   // Use message from backend
                 showDialogOnCatch: false,
                customErrorMessages: {
                    [ErrorTypes.FORBIDDEN]: 'You cannot view dashboards for this project.'
                },
                onSuccess: (response) => {
                    console.log("Dashboards fetched:", response);
                    if (response.data.success && response.data.data && response.data.data?.dashboards) {
                        setConfigDashboards(response.data.data.dashboards || []);
                    }else {
                        setConfigDashboards([]);
                    }
                    setLoading(false);
                },
                onError: (response) => {
                    console.error("Failed to fetch dashboards:", response);
                    setConfigDashboards([]);
                    setLoading(false);
                },
                onCatchError: (error, errorInfo) => {
                    console.error(" Unexpected error fetching dashboards:", error, errorInfo);
                    setConfigDashboards([]);
                    setLoading(false);
                }
            }
        );
    };

    function handleDelete(currentDashboard) {
        console.log("handleDelete clicked for dashboard", currentDashboard);
        setDeleteDashboardObject(currentDashboard)
        setDeleteMode(true) 
    }

    function handleCloseDeleteDashboard(){
        setDeleteMode(false) 
        setDeleteDashboardObject(null);
    }

    async function handleConfirmDialogDeleteDashboard(){
        if (!deleteDashboardObject) return;
        
        setDeleteMode(false);
        setLoading(true);

        await callApi(
            () => maintenanceApi.deleteDashboard(deleteDashboardObject.dashboard_pro),
            {
                showDialog: true,  // Always show dialog for delete operations
                hideDialogOnStatusCodes: [404],
                successTitle: 'Dashboard Deleted',
                successMessage: `Dashboard "${deleteDashboardObject.Dashboardname}" deleted successfully`,
                useBackendMessage: true,  // Use custom message
                showDialogOnCatch: false,
                customErrorMessages: {
                    [ErrorTypes.NOT_FOUND]: 'Dashboard not found. It may have been already deleted.',
                    [ErrorTypes.FORBIDDEN]: 'You do not have permission to delete this dashboard.',
                    [ErrorTypes.SERVER_ERROR]: 'Failed to delete dashboard. Please try again.'
                },
                onSuccess: (response) => {
                    console.log("Delete successful:", response);
                    if (response.data.success && response.data?.data && response.data?.data?.data) {
                        setConfigDashboards(response.data?.data?.data);
                        setNotCreatedMessage(response.data.message || `Dashboard "${deleteDashboardObject.Dashboardname}" deleted successfully`);
                        setDeleteDashboardSuccess(true);
                        // Refresh plantview after successful delete
                        //refreshPlantview(dispatch, userdetails?.Organizationid, userdetails?.Projectid === "All" ? projectname : userdetails?.Projectid);
                        getplantview(userdetails?.Organizationid, userdetails?.Projectid === "All" ? projectname : userdetails?.Projectid, (res) => {
                                                        console.log("res in refreshPlantview StatusTableDashboard",res)
                                                        if (res && res.plantview) {
                                                            dispatch(updateplatjson(res.plantview));
                                                        }
                                                    });
                    } else {
                        setDeleteDashboardFailed(true);
                        setNotCreatedMessage(response.data.message || "Failed to delete dashboard.");
                    }
                    setLoading(false);
                },
                onError: (error) => {
                    console.error("Error deleting dashboard:", error);
                    setDeleteDashboardFailed(true);
                    setNotCreatedMessage(error?.message || "Failed to delete dashboard. Try Again!");
                    setLoading(false);
                },
                onCatchError: (error, errorInfo) => {
                    console.error("Unexpected error deleting dashboard:", error, errorInfo);
                    setNotCreatedMessage(error?.message || "Unexpected error deleting dashboard.");
                    setDeleteDashboardFailed(true);
                    setLoading(false);
                },
                dialogConfig: {
                    confirmText: 'OK'
                }
            }
        );
    }

    return (<>
            {/* Custom Dialog Box - Single instance */}
            <CustomDialogBox 
                dialogTitle={dialogState.title}
                dialogText={dialogState.message}
                openDialog={dialogState.open}
                handleCloseDialog={() => {
                    closeDialog();
                    if (dialogState.onCancel) {
                        dialogState.onCancel();
                    }
                }}
                handleConfirmDialog={() => {
                    if (dialogState.onConfirm) {
                        dialogState.onConfirm();
                    } else {
                        closeDialog();
                    }
                }}
                confirmText={dialogState.confirmText}
                cancelText={dialogState.cancelText}
                type={dialogState.type}
            />

            {/* Delete Confirmation Dialog */}
            <CustomDialogBox 
                dialogTitle={"Delete Dashboard"} 
                dialogText={`Are you sure you want to delete "${deleteDashboardObject?.Dashboardname}"?`}  
                openDialog={deleteMode}  
                handleCloseDialog={handleCloseDeleteDashboard}  
                handleConfirmDialog={handleConfirmDialogDeleteDashboard}  
                confirmText={"Yes"}  
                cancelText={"No"} 
                type={"Warning"}
            />

            {/* Delete Success Dialog */}
            <CustomDialogBox 
                dialogTitle={"Success"} 
                dialogText={notCreatedMessage}  
                openDialog={deleteDashboardSuccess}  
                handleCloseDialog={() => setDeleteDashboardSuccess(false)}  
                handleConfirmDialog={() => setDeleteDashboardSuccess(false)}  
                confirmText={"OK"}  
                type={"Success"}
            />

            {/* Delete Failure Dialog */}
            <CustomDialogBox 
                dialogTitle={"Error"} 
                dialogText={notCreatedMessage}  
                openDialog={deleteDashboardFailed}  
                handleCloseDialog={() => setDeleteDashboardFailed(false)}  
                handleConfirmDialog={() => setDeleteDashboardFailed(false)}  
                confirmText={"OK"}  
                type={"Error"}
            />

            <Box sx={{boxSizing:"border-box",padding:"8px",background:'var(--PrimaryBackground)',height:'calc(93%)',marginBottom:"0px",overflow:"hidden"}}>
                <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"0px",marginTop:"6px", textAlign:"left"}}>Dashboards List</Typography>
                {!loading ? (<TableContainer component={Paper} sx={{ width: '100%', maxHeight:"calc(100% - 40px)",paddingLeft:'0px',backgroundColor:'var(--secondary-backgroundLK)',paddingRight:'0px', overflow:'auto' }} elevation={0}>
                    <Table sx={{ width: '100%' }} size="large" stickyHeader>
                        <TableHead>
                            <TableRow sx={{border:"0px"}}>
                                <TableCell align="left" sx={{ fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)",backgroundColor:'var(--secondary-backgroundLK)'}}><CustomTableHeading children={'Dashboards'} /></TableCell>
                                <TableCell align="left" sx={{ fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)",paddingLeft:4.5,backgroundColor:'var(--secondary-backgroundLK)'}}><CustomTableHeading children={'Delete'} /></TableCell>
                                {/*<TableCell align="left" sx={{ fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)",paddingLeft:4.5}}><CustomTableHeading children={'Clone'} /></TableCell>*/}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {((Array.isArray(configDashboards)) && (configDashboards.length != 0)) ? configDashboards.map((currentDashboard, index) => (
                                <TableRow key={currentDashboard.id} 
                                    sx={{
                                        '&:last-child td, &:last-child th': { border: 0 },
                                        height:"9px",
                                        '& > *': { borderBottom: "1px solid var(--table-boarder-line)" },
                                        cursor: 'pointer',
                                        '&:hover': {
                                            backgroundColor: 'rgba(0, 140, 215, 0.08)',
                                        },
                                        '&:active': {
                                            backgroundColor: 'rgba(0, 140, 215, 0.15)',
                                        }
                                    }}>
                                    {console.log("currentDashboard---///",currentDashboard)}
                                    <TableCell component="th" scope="row" sx={{ fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}><CustomTableMetric children={ currentDashboard.Dashboardname }/></TableCell>
                                    <TableCell component="th" scope="row" sx={{ fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}><Button sx={{padding:"0px",fontSize:"16px",fontFamily:"Roboto",textTransform:'capitalize', backgroundColor:"var(--SecondaryBackground)", borderRadius:"20px", boxShadow: "none",paddingLeft:0}} variant="text" onClick={() => handleDelete(currentDashboard)} disableTouchRipple elevation={0}><LK_Delete color={"#005C8E"} width={"25px"} height={"25px"}/></Button></TableCell>
                                </TableRow>
                            )): <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"0px",marginTop:"6px", textAlign:"left"}}>No Dashboards Found</Typography>}
                        </TableBody>
                    </Table>
                </TableContainer>)
                :<Box sx={{gap:'8px',boxSizing:"border-box",height:'calc(100%)',width:'100%',overflow:"auto",alignContent:"center"}} >
                    <img src={LK_Loading} alt="loading..." style={{height:"15%" ,width:"auto",alignSelf:"center"}} />
                </Box>}
        </Box>
    </>)
}